import React, { useEffect, useState } from 'react';

const ANNOUNCEMENT_KEY = 'announcementBannerDismissed_v1';
const ANNOUNCEMENT_EXPIRY = 1000 * 60 * 60 * 24 * 5; // 5 days in ms
const ANNOUNCEMENT_DATE = '2025-06-02T00:00:00Z'; // Start date of the announcement (today)

const AnnouncementBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Check if the banner was already closed and if the period expired
    const dismissed = localStorage.getItem(ANNOUNCEMENT_KEY);
    const now = Date.now();
    const start = new Date(ANNOUNCEMENT_DATE).getTime();
    if (dismissed) {
      const { time } = JSON.parse(dismissed);
      if (now - time < ANNOUNCEMENT_EXPIRY) return;
    }
    // Only show if within 5 days after the start date
    if (now - start < ANNOUNCEMENT_EXPIRY) setVisible(true);
  }, []);

  const handleClose = () => {
    localStorage.setItem(ANNOUNCEMENT_KEY, JSON.stringify({ time: Date.now() }));
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="announcement-banner">
      <div className="announcement-content">
        <strong>⚠️ Attention: FGOL Token Delisting from Probit!</strong>
        <span>
          Our token will be <b>delisted from Probit on 08/06</b>. If you have tokens on Probit, <b>withdraw them immediately</b> and <b>do not send any more tokens there</b>.<br />
          From now on, trading is only available on decentralized exchanges (DEX).
        </span>
      </div>
      <button className="announcement-close" onClick={handleClose} aria-label="Close announcement">×</button>
    </div>
  );
};

export default AnnouncementBanner; 